const initialLot = {
  break_samples: [],
  absorption_samples: [],
  fabrication_date: "",
  fbk: undefined,
  width: undefined,
  height: undefined,
  length: undefined,
  provider: "",
  amount_acceptance: undefined,
  amount_break: undefined,
  amount_absorption: undefined,
  discarded: false,
  notes: "",
  place: "",
  trace: "",
  invoice: "",
  prism: false,
  lot: "",
  collect_date: "",
  validation: false,
  calculate_conformity: true,
  group: "",
  product: "",
  contract: undefined
};

export { initialLot };
